import React from "react";
import {TransitionGroup, CSSTransition} from "react-transition-group";

class LoadingScreen extends React.Component {

  render() {
    return (
      <div className="loading-screen">
        <h1 className="loading-screen-heading">Loading...</h1>
      </div>
    );
  }
}

export default LoadingScreen;
